import type { ReactNode } from "react";
import { FilterProvider } from "./FilterContext";
import type { FilterCategoryGroup } from "./types";

interface FilterRootProps {
  children: ReactNode;
  categoryGroups: FilterCategoryGroup[];
}

export function FilterRoot({ children, categoryGroups }: FilterRootProps) {
  return (
    <FilterProvider categoryGroups={categoryGroups}>{children}</FilterProvider>
  );
}
